import { render, staticRenderFns } from "./PosSelectList.vue?vue&type=template&id=96f73b4a&"
import script from "./PosSelectList.vue?vue&type=script&lang=js&"
export * from "./PosSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports